(function(){


function updateCartDiscount(){


const source =
document.querySelector('.price-discount-source');


const button =
document.querySelector('button[name="add"]');


if(!source || !button){
return;
}


const discount =
source.dataset.discount;


if(!discount){
return;
}


const text =
'Add to cart\u00A0\u00A0—\u00A0\u00A0Save '+discount+'%';



if(button.textContent !== text){

button.setAttribute(
'data-add-to-cart-text',
text
);


button.textContent=text;

}



}



function init(){


updateCartDiscount();



const productInfo =
document.querySelector('.product-info');


if(!productInfo){
return;
}



const observer =
new MutationObserver(function(){

updateCartDiscount();

});



observer.observe(
productInfo,
{
childList:true,
subtree:true
}
);



}



if(document.readyState === 'loading'){

document.addEventListener(
'DOMContentLoaded',
init
);

}else{

init();

}



})();